module.exports = __webpack_public_path__ + "static/home-hero-background-2b5fcdd6da9575327d96daba2fc1d21e.png";